export default __webpack_public_path__ + "static/media/added.43693a33.svg";